import React from 'react'
import styled from 'styled-components'
import { ITabItemProp } from './TabItem.types'
import { STYLES } from '../../static/style'

const StyledTabs = styled.div``

const TabHeadersContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${STYLES.BORDER_COLOR};
`

const TabHeader = styled.div`
  padding: 0.5rem;
  border: 1px solid ${STYLES.BORDER_COLOR};
  border-bottom: 0;
  border-radius: ${STYLES.BORDER_RADIUS} ${STYLES.BORDER_RADIUS} 0 0;
  margin-right: 0.1rem;
  cursor: pointer;
  margin-bottom: -1px;
  background-color: ${STYLES.COLOR_WHITE};
  &:hover {
    background-color: ${STYLES.COLOR_MERCURY_GRAY};
  }
  ${({ active }) =>
    active &&
    `
    background-color: ${STYLES.PRIMARY_COLOR} !important;
    color: ${STYLES.COLOR_BLACK};
    cursor: default;
    font-weight: bold;
    &:hover {
      background-color: ${STYLES.PRIMARY_COLOR};
    }
  `}
`

const TabContent = styled.div``

interface ITabsProps {
  items: Array<ITabItemProp>
  activeItemId?: number
  onItemHeaderClick: (id: string) => void
  className?: string
}
const Tabs: React.FC<ITabsProps> = ({
  items,
  activeItemId,
  onItemHeaderClick,
  className,
}) => {
  const activeItem = items.find(({ id }) => id === activeItemId)
  return (
    <StyledTabs className={className}>
      <TabHeadersContainer>
        {items.map(({ header, style, id }) => (
          <TabHeader
            style={style}
            active={id === activeItemId}
            key={id}
            onClick={() => onItemHeaderClick(id)}
          >
            {header}
          </TabHeader>
        ))}
      </TabHeadersContainer>
      <TabContent>{activeItem && activeItem.content}</TabContent>
    </StyledTabs>
  )
}

export { Tabs }
